module.exports = __webpack_public_path__ + "img/u96.cac30faa.png";